module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/HISTORY OF ART-688872c3a151f68127739ec1cbab9ed2.png";